/* eslint-disable no-console */

import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import WrenchIcon from 'mdi-react/WrenchIcon'
import classnames from 'classnames'
import {
  CardBody,
  Col,
  Row,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap'
import { removeCookiesHandler } from 'Constants/functions'
import { signInAs } from 'Redux/actions/auth'
import UsersTable from './components/Users'
import PayoutsTable from './components/Payouts'
import PlaylistsTable from './components/PlaylistsTable'
import SFAInput from './components/SFATable'

const AdminPanel = ({
  artists,
  curators,
  history,
  usersCount,
  getArtists,
  getCurators,
  allFoundUsers,
  searchUsers,
  getPayouts,
  totalBalance,
  payoutToCurator,
  sendRecipientCheckingNeeded,
  blockCurator,
  getPaidPayouts,
  getAwaitingPayouts,
  paidPayouts,
  awaitingPayouts,
  payoutCounters,
  playlists,
  totalPlaylists,
  getPlaylistsListAdmin,
  searchPlaylists,
  allFoundPlaylists,
  getPlaylistInfo,
  setIsNewParameter,
  activatePlaylist,
  deactivatePlaylist,
  changeCuratorValidation,
  getMonthlyListeners,
}) => {
  const dispatch = useDispatch()

  const [activeTab, setActiveTab] = useState('1')

  const toggle = tab => {
    activeTab !== tab ? setActiveTab(tab) : null
  }

  const handleLoginAs = async (id, isArtist) => {
    removeCookiesHandler()
    localStorage.removeItem('persist:root')
    localStorage.removeItem('persist:auth')
    try {
      await dispatch(
        signInAs(id, isArtist, error => {
          if (!error) {
            history.push('/')
          }
        })
      )
      setTimeout(() => {
        history.go(0)
      }, 1000)
    } catch (error) {
      console.log('error', error)
    }
  }

  const handleValidate = id => {
    changeCuratorValidation(id)
  }

  return (
    <Container className="dashboard">
      <Col>
        <Row>
          <Col md={12}>
            <h3 className="page-title">
              <WrenchIcon /> Users Management
            </h3>
          </Col>
        </Row>
        <div className="tabs tabs--bordered-bottom main-admin-tabs">
          <div className="tabs__wrap admin-tabs">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === '1' })}
                  onClick={() => {
                    toggle('1')
                  }}
                >
                  Users &ensp;
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === '2' })}
                  onClick={() => {
                    toggle('2')
                  }}
                >
                  Payouts &ensp;
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === '3' })}
                  onClick={() => {
                    toggle('3')
                  }}
                >
                  Playlists &ensp;
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === '4' })}
                  onClick={() => {
                    toggle('4')
                  }}
                >
                  SFA &ensp;
                </NavLink>
              </NavItem>
            </Nav>
          </div>
        </div>
        <CardBody>
          <TabContent activeTab={activeTab}>
            {activeTab === '1' && (
              <TabPane tabId="1">
                <UsersTable
                  allFoundUsers={allFoundUsers}
                  artists={artists}
                  blockCurator={blockCurator}
                  curators={curators}
                  getArtists={getArtists}
                  getCurators={getCurators}
                  handleLoginAs={handleLoginAs}
                  handleValidate={handleValidate}
                  history={history}
                  searchUsers={searchUsers}
                  usersCount={usersCount}
                />
              </TabPane>
            )}
            {activeTab === '2' && (
              <TabPane tabId="2">
                <PayoutsTable
                  artists={artists}
                  getPayouts={getPayouts}
                  getAwaitingPayouts={getAwaitingPayouts}
                  getPaidPayouts={getPaidPayouts}
                  handleLoginAs={handleLoginAs}
                  payoutToCurator={payoutToCurator}
                  sendRecipientCheckingNeeded={sendRecipientCheckingNeeded}
                  totalBalance={totalBalance}
                  awaitingPayouts={awaitingPayouts}
                  paidPayouts={paidPayouts}
                  payoutCounters={payoutCounters}
                />
              </TabPane>
            )}
            {activeTab === '3' && (
              <TabPane tabId="3">
                <PlaylistsTable
                  allFoundPlaylists={allFoundPlaylists}
                  playlists={playlists}
                  getPlaylists={getPlaylistsListAdmin}
                  history={history}
                  totalPlaylists={totalPlaylists}
                  searchPlaylists={searchPlaylists}
                  getPlaylistInfo={getPlaylistInfo}
                  setIsNewParameter={setIsNewParameter}
                  activatePlaylist={activatePlaylist}
                  deactivatePlaylist={deactivatePlaylist}
                />
              </TabPane>
            )}
            {activeTab === '4' && (
              <TabPane tabId="4">
                <SFAInput action={getMonthlyListeners} />
              </TabPane>
            )}
          </TabContent>
        </CardBody>
      </Col>
    </Container>
  )
}

export default AdminPanel
